import faireDirectDiscounts from "@faire/web-api/api/help-center/self-serve-faire-direct-discounts/get";
var NO_FAIRE_DIRECT_CONTEXT = {
  field: "faireDirectDiscountsContext",
  data: undefined
};
export var FaireDirectDiscountsDataFn = function FaireDirectDiscountsDataFn() {
  return faireDirectDiscounts().then(function (response) {
    return {
      field: "faireDirectDiscountsContext",
      data: response
    };
  })["catch"](function () {
    return NO_FAIRE_DIRECT_CONTEXT;
  });
};